export default "__VITE_ASSET__HKukJYwC__"